var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M36 19.96a1.992 1.992 0 00-2-1.984h-1.875l-2.56-2.54A1.506 1.506 0 0028.5 15h-3.495c-.385 0-.775.144-1.065.436l-2.55 2.54H19.5V16.86a.87.87 0 00-.875-.868h-3.25a.87.87 0 00-.875.868v1.116H14c-1.105 0-2 .888-2 1.984V31.37c0 1.096.895 1.984 2 1.984h20c1.105 0 2-.888 2-1.984V19.96zm-8.823 11.275a5.294 5.294 0 110-10.588 5.294 5.294 0 110 10.588zm0-8.47a3.177 3.177 0 100 6.353 3.177 3.177 0 000-6.353zm-9.107 0h-2.964c-.544 0-.988-.477-.988-1.06 0-.581.444-1.058.988-1.058h2.964c.544 0 .989.477.989 1.059s-.445 1.059-.989 1.059z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
